import React from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';
import { showUserDisplayName } from '../../../../lib/userUtils';
import { formatElapsedTime, getDateAndTime } from '../../../../lib/utils';
import SkeletonLoader from '../../../elements/SkeletonLoader';

const LabelValue = ({ label, value }) => (
  <Box>
    <Typography 
      variant="overline"
      color="text.secondary"
      display="block"
      gutterBottom
    >
      {label}
    </Typography>
    <Typography variant="body2"  color="text.primary">{value || '-'}</Typography>
  </Box>
);

const TestExecutionForm = ({ execution, users, elapsedTime, loading }) => {
  if (loading) return <SkeletonLoader />;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={3}>
          <LabelValue label="Key" value={execution?.key} />
        </Grid>
        <Grid item md={3}>
          <LabelValue label="Environment" value={execution?.environment?.name || 'None'} />
        </Grid>
        <Grid item md={3}>
          <LabelValue label="Iteration" value={execution?.iteration?.name || 'None'} />
        </Grid>
        <Grid item md={3}>
          <LabelValue
            label="Time Elapsed"
            value={formatElapsedTime(elapsedTime || execution?.actual_time) || 'None'}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid item md={3}>
          <LabelValue
            label="Execution Assigned To"
            value={showUserDisplayName(execution?.executed_by || null, users)}
          />
        </Grid>
        <Grid item md={3}>
          <LabelValue label="Executed On" value={getDateAndTime(execution?.updated_at)} />
        </Grid>
        <Grid item md={3}>
          <LabelValue label="Created On" value={getDateAndTime(execution?.created_at)} />
        </Grid>
      </Grid>
    </>
  );
};

export default TestExecutionForm;